import firebase from "firebase";
import _debug from "debug";

const debug = _debug("Mediacao:models:User.ts");

const UserDbKeys = ["name", "email", "roles", "photoUrl", "cellPhone", "cpf", "dataNascimento"];

export type UserRole = "admin" | "mediador" | "parte";
export const USERS_COLLECTION = "users";
export default class UserModel {
    public get firebase(): any {
        return this.firebaseUser;
    }

    public get userDb(): UserDb | undefined {
        return this.theUserDb;
    }

    public get isRealUser(): boolean {
        return this.firebaseUser != null;
    }

    public get temCadastroPreenchido(): boolean {
        if (this.theUserDb && this.theUserDb.cpf && this.theUserDb.dataNascimento) {
            return true;
        }
        return false;
    }

    public get name(): string {
        return this.theUserDb ? (this.theUserDb.name ? this.theUserDb.name : "") : "";
    }
    public static fetchUsersByEmail(emailBusca: string): Promise<UserDb[]> {
        console.log("User.fetchUsersByEmail", emailBusca);
        return firebase
            .firestore()
            .collection(USERS_COLLECTION)
            .where("email", ">=", emailBusca)
            .where("email", "<=", emailBusca + "\uf8ff")
            .get()
            .then(querySnapshot => {
                return querySnapshot.docs.reduce<UserDb[]>((acc: UserDb[], current: firebase.firestore.QueryDocumentSnapshot) => {
                    const data = Object.assign({ id: current.id }, current.data()) as UserDb;
                    acc.push(data);
                    return acc;
                }, []);
            });
    }
    public static async create(firebaseUser: any): Promise<UserModel> {
        // go get user from db
        const fetchedUserDb = await this.fetchUser(firebaseUser.uid, firebaseUser.email);
        debug("User from db:", fetchedUserDb);
        return new UserModel(firebaseUser as UserFirebase, fetchedUserDb);
    }
    public static empty(firebaseUser: any = null) {
        return new UserModel(firebaseUser);
    }
    public static hasRoleOf(roles: string[], userRoles: string[]): boolean {
        return roles.reduce((previous, current, currentIndex, array) => {
            return previous || userRoles.includes(current);
        }, false as boolean);
    }

    public static fromJson(myParsedInstance: any): UserModel {
        return Object.assign(UserModel.empty(), myParsedInstance);
    }

    public static async setUserdb(newUserDb: UserDb, roles?: string[]) {
        console.log("UserModel.setuUserdb");
        const userToBeSaved = this.copyFromIntefaceUserDb(newUserDb);

        const usersRef = firebase
            .firestore()
            .collection(USERS_COLLECTION)
            .doc(userToBeSaved.email);

        const userRef = await usersRef.get();

        if (!userToBeSaved.photoURL) {
            delete userToBeSaved.photoURL;
        }

        if (userRef.exists) {
            delete userToBeSaved.roles;
            await usersRef.update(userToBeSaved);
        } else {
            await usersRef.set(userToBeSaved);
        }

        return userToBeSaved as UserDb;
    }

    public static copyFromIntefaceUserDb(user: UserDb) {
        const copy: UserDb = {};
        for (const key of UserDbKeys) {
            if ((user as any)[key]) {
                (copy as any)[key] = (user as any)[key];
            }
        }
        return copy;
    }

    protected static async fetchUser(authId: string, email: string): Promise<UserDb> {
        const userRef = firebase
            .firestore()
            .collection(USERS_COLLECTION)
            .doc(email);
        const user = await userRef.get();
        if (user.exists) {
            const userData: any = user.data();
            if (!userData.authId) {
                userData.authId = authId;
                userData.roles = ["parte"];
                userRef.update(userData);
            }
            return Object.assign({ email }, userData) as UserDb;
        } else {
            // criar com o perfil de usuario normal
            const newUser = { email, authId, roles: ["parte"] };
            await userRef.set(newUser);
            return Object.assign({ email }, user) as UserDb;
        }
    }

    public readonly photoURL: string;
    constructor(private firebaseUser: any, private theUserDb?: UserDb) {
        if (firebaseUser && firebaseUser.photoURL) {
            this.photoURL = firebaseUser.photoURL;
        } else {
            if (theUserDb && theUserDb.photoURL) {
                this.photoURL = theUserDb.photoURL;
            } else {
                this.photoURL = "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
            }
        }
    }

    public hasRole(role: UserRole): boolean {
        if (this.theUserDb && this.theUserDb.roles) {
            return this.theUserDb.roles.includes(role);
        }
        return false;
    }

    public hasRoleOf(roles: UserRole[]): boolean {
        if (this.theUserDb && this.theUserDb.roles) {
            return roles.reduce((previous, current, currentIndex, array) => {
                return previous || this.hasRole(current);
            }, false as boolean);
        }
        return false;
    }

    public setFirebase(theFirebaseUser: any) {
        this.firebaseUser = theFirebaseUser;
    }
}
export interface UserDb {
    name?: string;
    email?: string;
    roles?: string[];
    photoURL?: string;
    cellPhone?: string;
    cpf?: string;
    dataNascimento?: string;
}

export interface UserFirebase {
    uid?: string;
    email?: string;
    photoURL?: string;
}
